import { Component, Input, OnInit, ViewChild } from '@angular/core';
import {
  ApexAxisChartSeries,
  ApexChart,
  ChartComponent,
  ApexDataLabels,
  ApexXAxis,
  ApexPlotOptions
} from "ng-apexcharts";

export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  plotOptions: ApexPlotOptions;
  // xaxis: ApexXAxis;
};

@Component({
  selector: 'app-bar',
  templateUrl: './bar.component.html',
  styleUrl: './bar.component.css'
})
export class BarComponent implements OnInit {
  @ViewChild("chart") chart: ChartComponent;
  public chartOptions: Partial<ChartOptions> | any;

  // Custom variables to plot chart
  @Input() barType: Partial<ChartOptions> | boolean ;
  @Input() xAxisLabels: Partial<ChartOptions> | any ;
  @Input() themeVal: Partial<ChartOptions> | any ;
  @Input() colors: Partial<ChartOptions> | any ;
  
  ngOnInit(): void {
    this.chartOptions = {
      series: [
        {
          name: "Count",
          data: this.themeVal
        }
      ],
      chart: {
        type: "bar",
        height: 300,
        toolbar: {
          show: false
        }
      },
      //colors: this.colors,
      colors: ['#092154', '#0D3180', '#0D3284', '#0D3387', '#0D3490', '#0D3581', '#0B41CD', '#3C67D7', '#6D8DE1', '#9DB3EB', '#CED9F5','#ced8f1','#d4ddf2','#d4ddf3','#d4ddf4','#d4ddf9'],
      plotOptions: {
        bar: {
          horizontal: this.barType,
          distributed: true,
          borderRadius: 4
        }
      },
      legend: {
        show: false
      },
      dataLabels: {
        enabled: false
      },
      xaxis: {
        categories: this.xAxisLabels
      }
    };
  }
}
